import { makeObservable, computed } from 'mobx';
import InputsStore from './InputsStore';
import SessionStore from './SessionStore';

export default class ControlStateStore {
    constructor(
        private readonly inputsStore: InputsStore,
        private readonly sessionStore: SessionStore
    ) {
        makeObservable(this, {
            actionsDisabled: computed
        });
    }

    get actionsDisabled() {
        return (
            this.sessionStore.isInitializing ||
            this.sessionStore.isLoading ||
            this.sessionStore.inProgress ||
            this.inputsStore.inputsLoading
        );
    }
}
